import React, { useMemo } from 'react';
import useFetch from '../../react-hooks/use-fetch';
import { InlineNotification, Link, PropTypes } from 'carbon-components-react';

type propTypeSiteAlertBanner = {
	endpoint: string;
};

type propTypeReponseData = {
	siteState: string;
	heading: string;
	subtitle: string;
	link: {
		target: string;
		href: string;
		label: string;
	};
};

const SiteAlertBanner = ({ endpoint }: propTypeSiteAlertBanner) => {
	const { response } = useFetch({
		args: { url: endpoint },
		id: 'site-alert-notification'
	});

	const responseData = useMemo(() => response?.data, [response]);

	return (
		<>
			{responseData?.length > 0 &&
				responseData.map((notification: propTypeReponseData) => (
					<InlineNotification
						kind="info"
						className="bx--grid ms-site-alert-banner__notification"
						title={notification.heading}
						subtitle={notification.subtitle}
						lowContrast={true}
						actions={
							notification.link && (
								<Link
									href={notification.link.href}
									target={notification.link.target}
								>
									{notification.link.label}
								</Link>
							)
						}
					/>
				))}
		</>
	);
};
export default SiteAlertBanner;
